import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import styled from '@emotion/styled';
import { LanguageIcon } from '@seedlang/icons';
import { isPresent, pixify } from '@seedlang/utils';
import Text from 'components/text';
import autobind from 'autobind-decorator';
import cx from 'classnames';

const Wrapper = styled.div`
  width: 100%;
  margin: 5px 0;
`;

const MeaningRow = styled.div`
  cursor: pointer;
  background: #f5f5f5;
  display: flex;
  padding: 10px;
  border-radius: 5px;
  align-items: center;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const RegisterLabel = styled.div`
  font-size: 12px;
  color: #666;
  margin-right: 12px;
`;

const MainContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const ExpandIcon = styled.i`
  margin: auto;
  height: 22px;
  color: #868686;
  font-size: 20px;
  pointer-events: none;
  margin-right: 5px;
`;

const ExpandedContent = styled.div`
  margin: 5px 5px 5px 0;
  padding: 5px 10px 5px 0;
  border-radius: 5px;
  padding-left: 10px;
`;

const SentenceItem = styled.div`
  margin-bottom: 10px;
  text-align: left;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SentenceText = styled.div`
  font-size: ${props => props.fontSize};
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
`;

const SentenceSource = styled.div`
  font-size: ${props => props.fontSize};
  color: #676767;
  display: flex;
  align-items: center;
`;

@observer
class Meaning extends React.Component {
  @observable expanded = false;

  static defaultProps = {
    fontSize: '16px',
    lineHeight: '22px',
  };

  @computed get languageId() {
    return this.props.meaning.sourcesForUser(this.props.user).map(source => source.source.languageId)[0];
  }

  @autobind toggleExpanded() {
    this.expanded = !this.expanded;
  }

  @autobind onClickSynonym(synonym) {
    if (this.props.onClickWord) {
      this.props.onClickWord(synonym);
    }
  }

  render() {
    return (
      <Wrapper>
        <MeaningRow onClick={this.toggleExpanded}>
          <ContentWrapper>
            <MainContent>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <LanguageIcon
                  margin='0 5px 0 0'
                  languageId={this.languageId}
                />
                <Text
                  fontSize={pixify(this.props.fontSize)}
                  lineHeight={pixify(this.props.lineHeight)}
                  textAlign='left'
                >
                  {this.props.meaning.sourceTextListForUser(this.props.user)}
                </Text>
              </div>
              {
                this.props.meaning.synonyms.length > 0 &&
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <LanguageIcon
                      margin='0 5px 0 0'
                      languageId={this.props.word.languageId}
                    />
                    <Text
                      fontSize={pixify(this.props.fontSize)}
                      lineHeight={pixify(this.props.lineHeight)}
                      textAlign='left'
                    >
                      {
                        this.props.meaning.synonyms.map((synonym, index) => (
                          <span key={synonym.id}>
                            <span
                              onClick={e => {
                                e.stopPropagation();
                                this.onClickSynonym(synonym);
                              }}
                              style={{ borderBottom: '2px solid #b5b5b5', cursor: 'pointer' }}
                            >
                              {synonym.targetTextWithDefiniteArticle}
                            </span>
                            {index < this.props.meaning.synonyms.length - 1 && ', '}
                          </span>
                        ))
                      }
                    </Text>
                  </div>
              }
            </MainContent>
          </ContentWrapper>
          {
            isPresent(this.props.meaning.register) &&
              <RegisterLabel>
                {this.props.meaning.register}
              </RegisterLabel>
          }
          <ExpandIcon
            className={cx('fa', {
              'fa-angle-down': !this.expanded,
              'fa-angle-up': this.expanded,
            })}
          />
        </MeaningRow>
        {
          this.expanded && this.props.meaning.sentences && this.props.meaning.sentences.length > 0 &&
            <ExpandedContent>
              {
                this.props.meaning.sentences.map(sentence => (
                  <SentenceItem key={sentence.id}>
                    <SentenceText fontSize={this.props.fontSize}>
                      <LanguageIcon
                        margin='0 5px 0 0'
                        languageId={this.props.word.languageId}
                      />
                      {sentence.targetText}
                    </SentenceText>
                    {
                      sentence.sources && sentence.sources.map(source => (
                        <SentenceSource key={source.id} fontSize={pixify(14)}>
                          <LanguageIcon
                            margin='0 5px 0 0'
                            languageId={source.languageId}
                          />
                          {source.text}
                        </SentenceSource>
                      ))
                    }
                  </SentenceItem>
                ))
              }
            </ExpandedContent>
        }
      </Wrapper>
    );
  }
}

export default Meaning;